module.exports = __webpack_public_path__ + "static/media/step15.2c19d624.png";